module.exports = __webpack_public_path__ + "img/2-1.df1442f0.svg";